var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ArtItem",on:{"click":_vm.enterDetail}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.defaultItem.articleName || _vm.$t("Detail.noName")))]),_c('div',{staticClass:"remark"},[_vm._v(_vm._s(_vm.defaultItem.articleDescribe))]),_c('div',{staticClass:"updateTime"},[_vm._v(_vm._s(_vm.fomateDateTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }